module.exports = __webpack_public_path__ + "img/ic_arrow_after_g.c81ac879.svg";